import { Status } from 'hooks/requests/fetchUtils';
import useFetchApi from 'hooks/useFetchApi';
import { useState, useCallback } from 'react';
import useQueryParameters from 'hooks/useQueryParameters';
const PATH = '/api/magic_link_accept';

type MagicLinkAcceptanceHook = () => [
  (params: MagicLinkAcceptanceRequest) => Promise<void>,
  Status,
  boolean,
];

export interface MagicLinkAcceptanceRequest {
  magicLinkId: string;
  magicLinkOtp: string;
  verificationFingerprint: string;
}

export class MagicLinkAcceptanceError extends Error {}

const useMagicLinkAcceptance: MagicLinkAcceptanceHook = () => {
  const [error, setError] = useState<boolean>(false);
  const [status, fetch] = useFetchApi();
  const { mockMagicLinkAccept } = useQueryParameters();

  const magicLinkAcceptanceRequest = useCallback(
    async (params: MagicLinkAcceptanceRequest): Promise<void> => {
      setError(false);

      const response = await fetch(PATH, {
        method: 'POST',
        body: {
          magicLinkId: params.magicLinkId,
          otpCode: params.magicLinkOtp,
          verificationFingerprint: params.verificationFingerprint,
          mockResponse: mockMagicLinkAccept,
        },
      });

      if (response.ok) {
        return Promise.resolve();
      } else {
        setError(true);
        return Promise.reject(new MagicLinkAcceptanceError());
      }
    },
    [fetch, mockMagicLinkAccept],
  );

  return [magicLinkAcceptanceRequest, status, error];
};

export default useMagicLinkAcceptance;
